import br from './br'
import i18nPtBr from './i18nPtBr.json'
const i18n = require('vanilla-i18n')
i18n.setTranslate(br, 'br')
i18n.setTranslate(i18nPtBr, 'br')
i18n.setDefaultLanguage('br')
